import { render } from "./ConversationEscalationConfiguration.vue?vue&type=template&id=35eb7340&scoped=true&lang=pug"
import script from "./ConversationEscalationConfiguration.vue?vue&type=script&lang=js"
export * from "./ConversationEscalationConfiguration.vue?vue&type=script&lang=js"

import "./ConversationEscalationConfiguration.vue?vue&type=style&index=0&id=35eb7340&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35eb7340"]])

export default __exports__